import script from "./TabChartOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./TabChartOverview.vue?vue&type=script&setup=true&lang=js"

import "./TabChartOverview.vue?vue&type=style&index=0&id=019696e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019696e8"]])

export default __exports__